<div class="container">
  <ngx-spinner></ngx-spinner>

  @if (!showForm) {
    <div class="search-form"></div>
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by name" appTextNormalize>
        </mat-form-field>
      </div>

      <div class="search-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="!searchForm.name">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </form>

    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" [hidden]="!dataSource.data || dataSource.data.length === 0">
        <ng-container matColumnDef="matchedYearsIcon">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            @if (item.matchedYearsTooltip) {
              <mat-icon class="cell-info-icon" [matTooltip]="item.matchedYearsTooltip">info_outline</mat-icon>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Internal ID</th>
          <td mat-cell *matCellDef="let item">{{ item.code }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let item">{{ item.name }}</td>
        </ng-container>

        <ng-container matColumnDef="entityType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
          <td mat-cell *matCellDef="let item">
            <span class="type-badge" [ngClass]="Helpers.getEntityTypeBadgeClass(item.entityType)">
              {{ Helpers.getEntityTypeText(item.entityType) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item">
            <button mat-icon-button (click)="onConnect(item)">
              <mat-icon>navigate_next</mat-icon>
            </button>
            @if (canOpenInNewTab(item)) {
              <button mat-icon-button (click)="onOpenInNewTab(item, $event)"
                      matTooltip="Open the director in a new tab to check the CV">
                <mat-icon>open_in_new</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (!dataSource.data || dataSource.data.length === 0) {
        <div class="empty-state">
          No pyramid data available
        </div>
      }

      <mat-paginator
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [hidden]="!dataSource.data || dataSource.data.length === 0"
        aria-label="Select page">
      </mat-paginator>
    </div>
  }

  @if (showForm) {
    <app-add-pyramidal-pyramid-item
      [pyramidalShareholderId]="pyramidalShareholderId"
      [dialogRef]="dialogRef"
      [prefilledName]="connectedItemName"
      [prefilledCategoryId]="connectedCategoryId"
      [prefilledSubCategoryId]="connectedSubCategoryId"
      [connectedEntityId]="connectedEntityId"
      [connectedEntityType]="connectedEntityType"
      (formValidityChanged)="onFormValidityChange($event)">
    </app-add-pyramidal-pyramid-item>
  }
</div>
